<template>
<div class="partner" id="partners">
  <div class="module-logo">
    <div class="layout-content container">
      <!-- <div class="title" v-if="!isMobile">
        <img title="qrcode" src="@/assets/transSave/resource/image/a0/72/a0c0b1024614d81fdaca68c69759f172.png">
        <div class="title-desc">深圳香蜜湖<br>国际金融科技研究院</div>
      </div> -->
      <div class="content" :order="isMobile ? 1 : 0">
        <div class="content-item" v-for="(item, index) in data" :key="index">
          <div class="c-title">{{ item.title }}</div>
          <div class="c-content-wrap" :class="{ 'c-content-wrap--technical': item.title === '技术指导单位' || item.title === 'Technical Advisers' }">
            <div class="c-content" :class="{ 'c-content--ieee': each.indexOf('IEEE') !== -1 }" v-for="(each, idx) in item.list" :key="`${index}-${idx}`">{{ each }}</div>
          </div>
        </div>
      </div>
      <!-- <div class="title" v-if="isMobile">
        <img src="@/assets/transSave/resource/image/a0/72/a0c0b1024614d81fdaca68c69759f172.png">
        <div class="title-desc">深圳香蜜湖<br>国际金融科技研究院</div>
      </div> -->
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['data'],
  components: {
  },
  computed: {
    ...mapState(['isMobile'])
  }
}
</script>

<style lang="scss" scoped>

.partner {
  background: $bgGrey;
}

.module-logo {
  background: url('~@/assets/transSave/resource/image/50/4e/502eb0526ea3a56323f278d801e5024e.png') center / cover no-repeat;

  @include mobile {
    background: url('~@/assets/transSave/resource/image/96/c5/9656559cfcf2352b2532a1782c725ec5.png') center / cover no-repeat;
  }
}

// .partner-img {
//   // height: 206px;
//   width: 1077px; height: 236px;

//   @include mobile {
//     // height: 590px;
//     width: 266px; height: 630px;
//   }
// }

.container {
  display: flex;
  padding-top: 81px;
  padding-bottom: 81px;
  padding-left: 64px;

  @include mobile {
    display: block;
    padding: 19px 0 40px;
    text-align: center;
  }
}
.title {
  font-size: 12px;
  white-space: nowrap;
  line-height: 17px;
  text-align: center;

  img {
    width: 97px;
    margin: 0 auto 10px;

    @include mobile {
      margin: 0 auto 10px;
    }
  }

  @include mobile {
    margin-bottom: 28px;
    font-size: 12px;
    letter-spacing: 0.5px;
  }
}
.content {
  margin-left: 162px;
  margin-top: 8px;
  width: min(900px, calc(100% - 162px));

  @include mobile {
    margin: 0;
  }
}
.content-item {
  display: flex; flex-wrap: wrap;
  margin-bottom: 32px;

  @include mobile {
    display: block;
  }
}
.c-title {
  position: relative;
  flex: none;
  width: 132px;
  margin-right: 32px;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  line-height: 24px;
  white-space: normal;
  overflow-wrap: anywhere;

  @include mobile {
    display: inline-block;
    width: auto;
    margin: 0 0 13px;
    font-size: 15px;
  }

  &::after {
    content: '';
    position: absolute;
    left: -18px;
    top: 8px;
    width: 5px; height: 5px;
    background: #000000;
    transform: rotate(-45deg);
  }
}
.c-content-wrap {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 11px 28px;
  min-width: 0;

  @include mobile {
    display: block;
  }
}
.c-content-wrap--technical {
  align-items: flex-start;
}
.c-content-wrap--technical .c-content--ieee {
  white-space: nowrap;
}
@media screen and (min-width: 1181px) {
  .c-content-wrap--technical {
    display: grid;
    grid-template-columns: max-content max-content;
    column-gap: 28px;
    row-gap: 11px;
    align-items: start;
  }
  .c-content-wrap--technical .c-content {
    margin-bottom: 0;
    white-space: nowrap;
  }
}
.c-content {
  margin-bottom: 2px;
  font-size: 14px;
  line-height: 22px;

  @include mobile {
    margin-bottom: 8px;
  }
}

</style>
